import * as React from "react";

import debounce from "../lib/debounce";

export const useDebounce = (
  duration: number,
  proc: (...args: any[]) => Promise<void>,
) => {
  const ref = React.useRef(null);
  React.useEffect(() => {
    ref.current = debounce(duration, proc);
  }, [duration, proc]);

  return React.useMemo(() => {
    return (...args: any[]) => {
      ref.current?.(...args);
    };
  }, []);
};
